import HelpApi from '../common';
import {AnswerListResponse, SendMessageResponse} from './type';

export const getChatbotAnswerList = (
  contents: string,
): Promise<AnswerListResponse> =>
  HelpApi.post(
    '/api/help_chat.php',
    {
      type: 'question_autocomplete',
      contents,
      contents_cnt: 10, // 검색 컨텍스트 개수
      // limit: 10, // 유지할 대화 히스토리 개수
    },
    {},
  );

export const sendMessage = (
  user_message: string,
): Promise<SendMessageResponse> =>
  HelpApi.post(
    '/api/help_chat.php',
    {
      type: 'chat',
      user_message,
      // res_cnt: 10, // 검색 컨텍스트 개수
      // history_message_cnt: 10, // 유지할 대화 히스토리 개수
    },
    {},
  );
